(function () {
  'use strict';

  if (window.DkhounLazyVideo) {
    window.DkhounLazyVideo.init(document);
    return;
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const groups = new Map();
  let hasScrolled = window.scrollY > 0;
  let observer;

  function isRendered(video) {
    const rect = video.getBoundingClientRect();
    return rect.width > 1 && rect.height > 1 && getComputedStyle(video).visibility !== 'hidden';
  }

  function pause(video) {
    video.pause();
    video.classList.remove('is-dk-video-playing');
  }

  function play(video) {
    if (
      reducedMotion.matches ||
      document.hidden ||
      !isRendered(video) ||
      (video.dataset.dkVideoAfterScroll === 'true' && !hasScrolled)
    ) return;

    if (video.dataset.dkVideoLoaded !== 'true') {
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.dataset.dkVideoLoaded = 'true';
      video.load();
    }

    const attempt = video.play();
    if (attempt && typeof attempt.then === 'function') {
      attempt.then(() => video.classList.add('is-dk-video-playing')).catch(() => {});
    }
  }

  function syncGroup(name) {
    const videos = groups.get(name);
    if (!videos) return;

    const viewportCenter = window.innerHeight / 2;
    const candidates = Array.from(videos).filter((video) => (
      video.dataset.dkVideoVisible === 'true' && isRendered(video)
    ));
    candidates.sort((left, right) => {
      const leftRect = left.getBoundingClientRect();
      const rightRect = right.getBoundingClientRect();
      return Math.abs(leftRect.top + leftRect.height / 2 - viewportCenter) -
        Math.abs(rightRect.top + rightRect.height / 2 - viewportCenter);
    });

    const active = candidates[0];
    videos.forEach((video) => {
      if (video === active) play(video);
      else pause(video);
    });
  }

  function observe(video) {
    if (video.dataset.dkLazyVideoReady === 'true') return;
    video.dataset.dkLazyVideoReady = 'true';

    const group = video.dataset.dkVideoGroup;
    if (group) {
      if (!groups.has(group)) groups.set(group, new Set());
      groups.get(group).add(video);
    }

    observer.observe(video);
  }

  function init(scope) {
    scope.querySelectorAll('video[data-dk-lazy-video]').forEach(observe);
  }

  observer = new IntersectionObserver((entries) => {
    const changedGroups = new Set();

    entries.forEach((entry) => {
      const video = entry.target;
      const visible = entry.isIntersecting && entry.intersectionRatio >= 0.2 && isRendered(video);
      video.dataset.dkVideoVisible = visible ? 'true' : 'false';

      if (video.dataset.dkVideoGroup) {
        changedGroups.add(video.dataset.dkVideoGroup);
      } else if (visible) {
        play(video);
      } else {
        pause(video);
      }
    });

    changedGroups.forEach(syncGroup);
  }, { rootMargin: '80px 0px', threshold: [0, 0.2, 0.6] });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      document.querySelectorAll('video[data-dk-lazy-video]').forEach(pause);
      return;
    }
    groups.forEach((videos, name) => syncGroup(name));
    document.querySelectorAll('video[data-dk-lazy-video]:not([data-dk-video-group])').forEach((video) => {
      if (video.dataset.dkVideoVisible === 'true') play(video);
    });
  });

  const handleReducedMotion = () => {
    if (reducedMotion.matches) document.querySelectorAll('video[data-dk-lazy-video]').forEach(pause);
  };
  if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', handleReducedMotion);
  else reducedMotion.addListener(handleReducedMotion);

  window.addEventListener('scroll', () => {
    if (hasScrolled) return;
    hasScrolled = true;
    groups.forEach((videos, name) => syncGroup(name));
    document.querySelectorAll('video[data-dk-lazy-video]:not([data-dk-video-group])').forEach((video) => {
      if (video.dataset.dkVideoVisible === 'true') play(video);
    });
  }, { passive: true });

  window.DkhounLazyVideo = { init };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
}());
